export default __webpack_public_path__ + "static/media/lodgify_step5.bf141b4d.jpg";